(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["cqReactEditableComponents"] = factory();
	else
		root["cqReactEditableComponents"] = factory();
})((function(){ try{ return typeof self !== 'undefined';}catch(err){return false;}})() ? self : this, function() {
return 